import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDnsDetails, getDnsDetailsAction } from "../../actions/sub-domain";
import "../../assets/css/recommendation-modal.css";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const Domain = () => {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [domainFilter, setDomainFilter] = useState([]);

  const [filterData, setfilterData] = useState([]);
  const [search, setSearch] = useState("");
  const [totalItems, setTotalItem] = useState("");
  const [startDate, setStartDate] = useState('');
  const [actionNote, setActionNote] = useState("");
  const [isModalTwo, setModalTwo] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [endDate, setEndDate] = useState('');
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [limit, setLimit] = useState(10);
  const [category, setCategory] = useState("all");
  const [recordTypeFilter, setRecordTypeFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [action, setAction] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const auth = useSelector((state) => state?.auth?.user);
  const org = useSelector(
    (state) =>
      state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  let dnsDetailsArray = useSelector(
    (state) => state?.subDomain?.dnsDetails?.data
  );

  let total = useSelector(
    (state) => state?.subDomain?.dnsDetails?.totalDocs
  );

  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });

  let domain = org?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain?.length - 1) == "/") {
    domain = [domain?.substr(0, domain?.length - 1)];
  } else {
    domain = [domain];
  }

  if (org?.domains && org?.domains?.length > 0) {
    domain = org?.domains;
  }

  let scanCompleted = useSelector((state) => state?.subDomain?.scanCompleted);

  useEffect(() => {
    if (orgId) {
      getDnsDetails(orgId, true, dispatch, page, limit, search, filterData, category, recordTypeFilter, typeFilter);
    } else {
      getDnsDetails(id, true, dispatch, page, limit, search, filterData, category, recordTypeFilter, typeFilter);
    }
  }, [id, page, search, limit, filterData, category, recordTypeFilter, typeFilter]);

  useEffect(() => {
    setTotalItem(total)
  }, [total])

  let distinctArray = [];
  dnsDetailsArray?.reduce((arr, curr) => {
    let _key = curr?.subDomain + "-" + curr?.recordType;
    if (!arr[_key]) {
      arr[_key] = _key;
      distinctArray.push(curr);
    }
    return arr;

  }, {})

  dnsDetailsArray = distinctArray;

  const filterValue = dnsDetailsArray?.map((row) => row?.recordType);
  let distinctFilter = filterValue?.filter(
    (item, index, self) => self.indexOf(item) === index
  );

  distinctFilter?.unshift("all");

  const issuesFound = dnsDetailsArray?.filter(
    (row) =>
      row?.recordType == "spf" &&
      !row?.valid &&
      row?.record?.indexOf("SPF TXT record") == -1 &&
      row?.record?.indexOf("does not exist") == -1
  );
  const warningFound = dnsDetailsArray?.filter(
    (row) =>
      (row?.recordType == "dmarc" && !row?.valid) ||
      (row?.recordType == "MX" && row?.hosts?.length > 0 && !row?.valid)
  );

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  const downloadCsvData = dnsDetailsArray?.map((row) => ({
    // Status: res.valid ? "OK" : "ERROR",
    DomainName: row?.subDomain,
    RecordType: row?.recordType,
    Record: JSON.stringify(
      row?.recordType == "MX"
        ? row?.valid
          ? row?.hosts?.map((row) => row[0]?.hostname)
          : row?.warnings?.map((row) => row?.hostname)
        : row?.record
    )?.replace(/[\[\]']+/g, "")?.replace(/['"]+/g, ""),
    LastUpdated: moment(row?.createdAt).format("DD-MM-YYYY"),
  }));


  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }


  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/getDnsDetails/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}DNS Records.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  let domainSearch = [];
  domainFilter?.reduce((arr, curr) => {
    dnsDetailsArray?.map((res) => {
      if (res.subDomain == curr)
        domainSearch.push(res);
    })
  }, {})
  dnsDetailsArray = domainFilter?.length > 0 ? domainSearch : dnsDetailsArray;

  let mapData = dnsDetailsArray;
  let currentTableData = [];
  if (mapData && mapData?.length > 0) {
    currentTableData = mapData
  }

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event, name) => {
    if (event == "markAsRemidiated") {
      const data = {
        action: "markAsRemidiated",
        spfDmarcIds: selectedIds == 0 ? _id : selectedIds,
        actionNote: "",
        for: "forever",
        techName: name,
      };
      getDnsDetailsAction(
        id, true, dispatch, page, limit, search, filterData, category, data, recordTypeFilter, typeFilter
      );
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    const data = {
      action: "resetAction",
      spfDmarcIds: selectedIds == 0 ? [_id] : selectedIds,
    };
    getDnsDetailsAction(
      id, true, dispatch, page, limit, search, filterData, category, data, recordTypeFilter, typeFilter
    );
    setSelectedIds([]);
  };


  const addModal = () => {
    setModalTwo("Form Wizard modal two");
  };


  const submit = () => {
    const data = {
      action: action,
      spfDmarcIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    getDnsDetailsAction(
      id, true, dispatch, page, limit, search, filterData, category, data, recordTypeFilter, typeFilter
    );
    setModalTwo("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Email security</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li className="breadcrumb-item active" aria-current="page" style={{ color: 'white' }}>
                    SPF & DMARC Records
                  </li>
                </ol>
                <br />
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs">
              <span className="d-flex justify-content-end">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  className="btn btn-sm btn-primary mr-1"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                  Recommendation
                </a>
                {currentTableData?.length === 0 ? null : (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile();
                    }}
                    href="/add-report"
                    className="btn btn-sm btn-primary mr-1 download-report"
                  >
                    Download Details
                  </a>
                )}
              </span>
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <a
              className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("all");
                setPage(1);
                setfilterData([]);
                setSearch("");
              }}
            >
              Current
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("risk-accepted");
                setPage(1);
                setfilterData([]);
                setSearch("");
              }}
            >
              Risk Accepted
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("false-positive");
                setPage(1);
                setfilterData([]);
                setSearch("");
              }}
            >
              False Positive
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("remidiated");
                setPage(1);
                setfilterData([]);
                setSearch("");
              }}
            >
              Remediated
            </a>
          </li>
        </ul>
        <div className="card card_tableBox">
          <div className="body">
            <div className="d-flex justify-content-between align-items-center">
              <h6>Details</h6>
              <div className="filterBox">
                <select className="form-control form-control-sm ml-0 my-1" onChange={(e) => setfilterData(e.target.value)}>
                  <option value="">All Domains</option>
                  {domain?.map((item) => (
                    <option value={item}>{item}</option>
                  ))}
                </select>
                <select 
                  className="form-control form-control-sm ml-0 my-1" 
                  value={recordTypeFilter}
                  onChange={(e) => {
                    setRecordTypeFilter(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="all">All Records</option>
                  <option value="spf">SPF</option>
                  <option value="dmarc">DMARC</option>
                </select>
                <select 
                  className="form-control form-control-sm ml-0 my-1" 
                  value={typeFilter}
                  onChange={(e) => {
                    setTypeFilter(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="valid">Valid</option>
                  <option value="invalid">Invalid</option>
                </select>
                {/* <Autocomplete
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setfilterData(newValue);
                  }}
                  value={filterData}
                  options={domain || []}
                  getOptionLabel={(option) => option?.toString()}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder="Select Domain"
                      style={{ color: 'black', width: '100%' }}
                    />
                  )}
                /> */}
                <div
                  className="searchBoxInput p-0"
                >
                  <input
                    class="form-control form-control-sm ml-0 my-1"
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    // value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPage(1);
                    }}
                  />
                </div>
                {selectedIds?.length > 1 && userPermission && category === "all" && (
                  <Box sx={{ width: 200 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedValue}
                        onChange={(event) => {
                          setAction(event.target.value);
                          snooze("", event.target.value);
                        }}
                      >
                        <MenuItem value="pleaseSelect">
                          Snooze Options
                        </MenuItem>
                        <MenuItem
                          value="riskAccepted"
                          onClick={() => {
                            addModal();
                          }}
                        >
                          Risk Accepted
                        </MenuItem>
                        <MenuItem
                          value="markAsFalsePositive"
                          onClick={() => {
                            addModal();
                          }}
                        >
                          False Positive
                        </MenuItem>
                        <MenuItem value="markAsRemidiated">
                          Remediated
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                )}
                {selectedIds?.length > 1 &&
                  (category == "false-positive" ||
                    category == "risk-accepted") && userPermission && (
                    <button
                      className="btn btn-primary btn-sm mr-1 Unsnooze"
                      onClick={() => Unsnoozed("")}
                    >
                      Unsnooze
                    </button>
                  )}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-custom spacing5 mb-0">
                <thead>
                  <tr>
                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>
                          <input
                            type="checkbox"
                            checked={selectedIds == 0 ? false : multiCheckTrue}
                            onClick={() => multicheck(currentTableData)}
                            className="checkUncheck"
                          />
                        </th>
                      )}
                    <th>Status</th>
                    <th>Domain Name</th>
                    <th>Record Type</th>
                    <th>Record</th>
                    <th>Observations</th>
                    {category !== "all" && <th>Action Note</th>}
                    <th>Last modified on</th>
                    {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {currentTableData?.map((row, index) => {
                    return (
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <input
                                onClick={() => singleClick(row?._id)}
                                checked={selectedIds?.includes(row?._id)}
                                type="checkbox"
                                className="checkUncheck"
                              />
                            </td>
                          )}
                        <td>
                          <span className={row?.valid ? "badge badge-success p-0" : "badge badge-danger p-0"}>
                            {row?.valid ? "Valid" : "Invalid"}
                          </span>
                        </td>
                        <td style={{ whiteSpace: "unset" }}>
                          <a href={`https://${row?.subDomain}`} target="_blank" style={{ color: "white" }}>
                            {row?.subDomain || row?.subDomain}
                          </a>
                        </td>
                        <td>{row?.recordType}</td>
                        <td style={{ whiteSpace: "unset" }}>
                          {row?.recordType == "MX"
                            ? row.valid
                              ? row?.hosts?.map((req) => {
                                return (
                                  <>
                                    <span>{req[0]?.hostname}</span>
                                    <br />
                                  </>
                                );
                              })
                              : row?.warnings?.map((req) => {
                                return (
                                  <>
                                    <span>{req?.hostname}</span>
                                    <br />
                                  </>
                                );
                              })
                            : row?.record || "N/A"}
                        </td>
                        <td style={{ whiteSpace: "unset" }}>
                          {row?.error ? row.error.replace(/[()'"]/g, '') : "N/A"}
                        </td>
                        {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                        <td style={{ whiteSpace: "unset", maxWidth: "250px" }}>
                          <span className="badge badge-success">
                            {moment(row?.updatedAt).format("DD-MM-YYYY")}
                          </span>
                        </td>
                        {row?.remediationPending == true ? <td>Retest in progress</td> : <>
                          {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                            <td>
                              <Box sx={{ width: 160 }}>
                                <FormControl fullWidth>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedValue}
                                    onChange={(event) => {
                                      setAction(event.target.value);
                                      snooze(
                                        row?._id,
                                        event.target.value,
                                        row?.name
                                      );
                                    }}
                                  >
                                    <MenuItem value="pleaseSelect">
                                      Snooze Options
                                    </MenuItem>
                                    <MenuItem
                                      value="riskAccepted"
                                      onClick={() => {
                                        addModal();
                                        setLookalikeAppId([row?._id]);
                                      }}
                                    >
                                      Risk Accepted
                                    </MenuItem>
                                    <MenuItem
                                      value="markAsFalsePositive"
                                      onClick={() => {
                                        addModal();
                                        setLookalikeAppId([row?._id]);
                                      }}
                                    >
                                      False Positive
                                    </MenuItem>
                                    <MenuItem value="markAsRemidiated">
                                      Remediated
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </td>
                          )}
                        </>
                        }
                        {auth?.accessLevel != "Threat Analyst" && (category === "risk-accepted" ||
                          category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze"
                                onClick={() =>
                                  Unsnoozed(
                                    row?._id,
                                    row?.name,
                                    row?.uuid
                                  )
                                }
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-content-center">
              <div className="dataTables_paginate">
                {totalItems > 10 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={limit}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
              {totalItems > 10 && (
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(e.target.value)
                  }}
                  className="form-control limitSelectBox"
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                  <option value={100}>100 per page</option>
                </select>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalTwo === "Form Wizard modal two" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalTwo("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModalTwo("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has identified misconfigured or missing DNS-based email authentication
                  records (SPF and DMARC). These weaknesses enable email spoofing, phishing
                  campaigns, and unauthorized email delivery using your domain.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are SPF & DMARC Records</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      SPF (Sender Policy Framework) and DMARC (Domain-based Message Authentication,
                      Reporting & Conformance) are DNS records that define which mail servers are
                      authorized to send emails on behalf of a domain and how unauthenticated emails
                      should be handled.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Issues Identified by BrandSek</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Missing DMARC records at root or base domain</li>
                      <li>Invalid or malformed SPF records</li>
                      <li>SPF records referencing non-existent domains</li>
                      <li>Domains without SPF TXT records</li>
                      <li>No DMARC policy enforcement (monitor-only or absent)</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Email spoofing and brand impersonation</li>
                      <li>Phishing attacks targeting customers and employees</li>
                      <li>Unauthorized email delivery bypassing controls</li>
                      <li>Reputation damage and email deliverability issues</li>
                      <li>Regulatory non-compliance (RBI, CERT-In, ISO 27001)</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Landscape Context</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Attackers routinely scan DNS records to identify domains without enforced DMARC
                      policies. Such domains are actively abused in phishing kits, BEC scams, and
                      malware delivery campaigns due to low resistance.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate DNS Remediation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Publish a valid DMARC record at the base domain</li>
                      <li>Fix invalid or malformed SPF records</li>
                      <li>Remove SPF includes pointing to non-existent domains</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.23 · Information Transfer Security</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>DMARC Policy Enforcement</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Start with DMARC policy set to p=none</li>
                      <li>Progressively enforce p=quarantine or p=reject</li>
                      <li>Enable DMARC aggregate (rua) and forensic (ruf) reports</li>
                    </ul>
                    <div className="compliance-tag">CERT-In Email Security Best Practices</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>SPF Hardening</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Include only authorized email sending servers</li>
                      <li>Ensure SPF ends with a strict -all policy</li>
                      <li>Avoid exceeding DNS lookup limits (≤10)</li>
                    </ul>
                    <div className="compliance-tag">RFC 7208 · SPF Specification</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Ongoing Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Continuously monitor SPF/DMARC status across domains</li>
                      <li>Review DMARC reports for abuse patterns</li>
                      <li>Periodically audit DNS records after vendor changes</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Continuous Monitoring</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Domain;
